import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ToolTipIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--tooltip')}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g>
      <circle id="Oval" cx="50" cy="50" r="50" />
      <path
        d="M33.9 40.1c.1-2.1.6-4.1 1.3-6 .7-1.9 1.7-3.6 3-5.1 1.3-1.5 2.9-2.7 5-3.6s4.3-1.3 6.9-1.3c3.3 0 6.1.7 8.5 2 2.4 1.3 4.1 3.1 5.2 5.2 1.1 2.2 1.6 4.6 1.5 7.3 0 2.4-.4 4.5-1.3 6.3-.9 1.8-2.6 3.9-5.1 6.2-.3.3-.8.9-1.5 1.6-.7.8-1.3 1.4-1.8 1.9-.4.5-.9 1.1-1.4 1.8-.5.7-.8 1.4-1 2-.2.9-.3 1.5-.3 1.9v4.1h-6.3v-3.6c0-2.3.7-4.4 2-6.4.6-1 1.5-2 2.5-3.1s2-2.1 2.8-2.9c.9-.9 1.7-1.8 2.5-2.8.8-1 1.4-2.1 1.9-3.4s.6-2.6.6-4.1c0-.6 0-1.2-.1-1.7-.1-.6-.3-1.3-.7-2.1-.4-.8-.8-1.5-1.4-2.1-.6-.6-1.4-1.2-2.6-1.6-1.1-.5-2.4-.7-3.9-.8-1.4 0-2.6.2-3.7.6-1.1.4-2 .9-2.7 1.5-.7.6-1.3 1.3-1.8 2.2-.5.9-.9 1.6-1.1 2.3-.2.7-.4 1.5-.6 2.3-.2.7-.3 1.3-.3 1.7v1.1l-6.1-1.4zm12.9 37v-6.5h6.5v6.5h-6.5z"
        className={s.toolTipTextColor}
        fill="#ffffff"
      />
    </g>
  </svg>
);

export default ToolTipIcon;
